import { render, staticRenderFns } from "./PropertyEditGeneral.vue?vue&type=template&id=06695298&scoped=true&"
import script from "./PropertyEditGeneral.vue?vue&type=script&lang=ts&"
export * from "./PropertyEditGeneral.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyEditGeneral.vue?vue&type=style&index=0&id=06695298&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06695298",
  null
  
)

export default component.exports